// Anmeldeseite (nur Billtoro): Hinweis, wenn eben die einzige Firma dieses Logins gelöscht wurde (dann endet auch die
// Sitzung, seiten/FirmaLoeschen.tsx merkt es sich in sessionStorage) oder das Steuerbüro seinen letzten Zugang
// zurückgegeben hat (mandanten/Mandant.tsx, Login gelöscht oder gesperrt). Einmal zeigen, dann vergessen.
import { useState } from 'react';
import { datum } from './anzeige';

export const GELOESCHT_SCHLUESSEL = 'bt-firma-geloescht';
export const ZURUECK_SCHLUESSEL = 'bt-zugang-zurueck';

// Eintrag lesen und gleich entfernen
function einmal(schluessel: string): Record<string, unknown> | null {
  try {
    const roh = sessionStorage.getItem(schluessel);
    sessionStorage.removeItem(schluessel);
    const h: unknown = roh ? JSON.parse(roh) : null;
    return h && typeof h === 'object' ? (h as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

export function GeloeschtHinweis() {
  const [hinweis] = useState<{ firma: string; datum: string } | null>(() => {
    const h = einmal(GELOESCHT_SCHLUESSEL);
    return h && typeof h.firma === 'string' && typeof h.datum === 'string' ? { firma: h.firma, datum: h.datum } : null;
  });
  const [zurueck] = useState<string | null>(() => {
    const h = einmal(ZURUECK_SCHLUESSEL);
    return h && typeof h.firma === 'string' ? h.firma : null;
  });
  if (zurueck) {
    return (
      <p className="notice info" role="status">
        Sie haben Ihren Zugang zu {zurueck} zurückgegeben. Ihr Login ist damit beendet.
      </p>
    );
  }
  if (!hinweis) return null;
  return (
    <p className="notice info" role="status">
      {hinweis.firma} ist gelöscht und Ihr Login damit beendet. Am {datum(hinweis.datum)} löschen wir alle Daten endgültig.
      Bis dahin stellen wir die Firma auf Wunsch wieder her.
    </p>
  );
}
